import { Column, Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { motion } from 'framer-motion';

import KnowledgeBadgeIcon from '../../images/eod/knowledge-badge-icon.svg';
import TimelinessBadgeIcon from '../../images/eod/timeliness-badge-icon.svg';
import TeamworkBadgeIcon from '../../images/eod/teamwork-badge-icon.svg';

const BADGE_SIZE = 91;

// Teal tint applied to selected badge background — no DS color token for this hue.
const BADGE_SELECTED_BG = '#E9F7F8';

// Circular badge container — DS borderRadius.pill = 25px; 50% creates a true circle.
const BADGE_CIRCLE_RADIUS = BADGE_SIZE / 2;

// Inner shadow ring sized slightly smaller than badge to create visible drop shadow on the image.
const BADGE_SHADOW_SIZE = BADGE_SIZE - 30;

const BADGES = [
  { Icon: KnowledgeBadgeIcon, value: 'knowledge', label: 'Knowledge' },
  { Icon: TimelinessBadgeIcon, value: 'timeliness', label: 'Timeliness' },
  { Icon: TeamworkBadgeIcon, value: 'teamwork', label: 'Teamwork' },
] as const;

interface RatingBadgesFeedbackProps {
  selectedBadges?: string[];
  onSelectBadge?: (value: string) => void;
}

export const RatingBadgesFeedback = ({
  selectedBadges = [],
  onSelectBadge = () => {},
}: RatingBadgesFeedbackProps) => (
  <Column data-cy="rating-badges-container" align="center" pt={16} gap={3}>
    <Typography
      bold
      size="heading_4"
      textAlign="center"
    >
      Did anything stand out?{' '}
      <Typography as="span" color={colors.neutral[500]}>
        (Optional)
      </Typography>
    </Typography>

    <Row data-cy="rating-badges-options" justify="center" gap={6}>
      {BADGES.map(({ Icon, value, label }) => {
        const isSelected = selectedBadges.includes(value);
        return (
          <Column
            key={value}
            data-cy={`badge-${value}`}
            align="center"
            gap={2}
            style={{ cursor: 'pointer' }}
            onClick={() => onSelectBadge(value)}
          >
            <motion.div
              style={{
                width: BADGE_SIZE,
                height: BADGE_SIZE,
                borderRadius: BADGE_CIRCLE_RADIUS,
                backgroundColor: isSelected ? BADGE_SELECTED_BG : undefined,
                opacity: isSelected ? 1 : 0.3,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              whileHover={{ scale: 1.05 }}
            >
              <div
                style={{
                  boxShadow: '2px 10px 20px rgba(0, 0, 0, 0.2)',
                  borderRadius: '50%',
                  width: BADGE_SHADOW_SIZE,
                  height: BADGE_SHADOW_SIZE,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <img
                  src={Icon}
                  alt={label}
                  style={{ width: BADGE_SIZE - 10, height: BADGE_SIZE - 10 }}
                />
              </div>
            </motion.div>
            <Typography textAlign="center">
              {label}
            </Typography>
          </Column>
        );
      })}
    </Row>
  </Column>
);
